import axios from 'axios'
// 地址
// axios.defaults.baseURL='https://tx4sdev.tongxianglive.cn/tx4s'
const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  // baseURL: 'https://tx4sdev.tongxianglive.cn/tx4s'
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(res=>{
  // console.log(res)
  return res
},err=>{
  return Promise.reject(err)
})

export default service